import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import { categories as categoryList } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = true }: ComicCardProps) {
  const categoryName = showCategory && comic.categories.length > 0
    ? categoryList.find(c => c.slug === comic.categories[0])?.name || ''
    : '';

  const statusText = comic.status === 'ongoing' ? '连载中' : '已完结';
  const statusClass = comic.status === 'ongoing'
    ? 'bg-accent-100 text-accent-800'
    : 'bg-secondary-100 text-secondary-800';

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫画免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 right-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${statusClass}`}>
            {statusText}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {comic.rating}
            </span>
            <span className="opacity-60">|</span>
            <span>{(comic.views / 10000).toFixed(0)}万阅读</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {comic.title}
      </h3>
      {showCategory && categoryName && (
        <div className="mt-1 flex items-center gap-2">
          <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
            {categoryName}
          </span>
        </div>
      )}
      <p className="mt-1 text-xs text-foreground-500">
        更新至 {comic.chapters.length} 话
      </p>
    </Link>
  );
}